import { Form, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './_SelectWorkflowAcesso.less';
import { useTranslation } from "react-i18next";
import useCollator from "../../../hooks/useCollator";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import axios from "axios";
import ActionBar from "../../../components/action-bar";
import ActionLink from "../../../components/action-link";

export default function SelectWorkflowAcesso(props) {
  const { workflowId, acesso, onSubmit, readOnly } = props;
  const { t } = useTranslation();
  const { compare, contains } = useCollator();
  const [form] = Form.useForm();
  const [edicao, setEdicao] = useState(false);
  const [acessos, setAcessos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const nome = searchValue.trim();

  const fireSubmit = acesso => {
    let promise = Promise.resolve();
    if (typeof onSubmit === 'function')
      promise = promise.then(() => onSubmit(acesso));
    return promise;
  };

  const handleClick = e => {
    if (readOnly)
      return;
    e.preventDefault();
    form.resetFields();
    setEdicao(true);
    setSearchValue('');
  };

  const handleFinish = values => {
    fireSubmit(values.acessoId).then(() => setEdicao(false));
  };

  useEffect(() => {
    setLoading(true);
    unwrapAxiosPromise(axios.get(`/workflows/${workflowId}/acessos`))
      .then(data => setAcessos(data))
      .finally(() => setLoading(false));
  }, [workflowId]);

  const acessosFiltradas = useMemo(() =>
      acessos
        .filter(acesso => contains(acesso.nome, nome))
        .sort((a, b) => compare(a.nome, b.nome))
        .slice(0, 50),
    [contains, acessos, nome]);


  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="acessoId" initialValue={acesso?.id} noStyle>
          <Select
            allowClear
            autoFocus
            className={styles['select']}
            filterOption={false}
            loading={loading}
            placeholder={t('Acesso')}
            searchValue={searchValue}
            onSearch={setSearchValue}
            showSearch
          >
            {acessosFiltradas.map(acesso => (
              <Select.Option key={acesso.id} value={acesso.id}>
                {acesso.nome}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <ActionBar>
          <ActionLink.Save onClick={form.submit}/>
          <ActionLink.Cancel onClick={() => setEdicao(false)}/>
        </ActionBar>
      </Form>
    );
  }

  let className = styles['workflow-tarefa-acesso'];
  if (!acesso)
    className += ' ' + styles['nao-preenchido'];
  if (readOnly)
    className += ' ' + styles['read-only'];

  return (
    <div className={className} onClick={handleClick}>
      <div className={styles['descricao']}>
        {acesso ? acesso.nome : t('(não preenchido)')}
      </div>
    </div>
  );
}

SelectWorkflowAcesso.propTypes = {
  workflowId: PropTypes.number,
  acesso: PropTypes.shape({
    id: PropTypes.number,
    nome: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  onUnload: PropTypes.func,
  readOnly: PropTypes.bool,
};
